import c from '../constants/Constants';
import $ from 'jquery';

require('es6-promise').polyfill();
require('isomorphic-fetch');


var productos = {

        getAll(filtros) {
            var esc = encodeURIComponent;
            var query = "";
            if (filtros)
                query = Object.keys(filtros)
                    .map(k => esc(k) + '=' + esc(filtros[k]))
                    .join('&');

            let defaultOptions = {
                url: '',
                method: 'GET',
                mode: 'cors',
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    "Content-Type": "application/json;charset=UTF-8",
                    
                },
                // cache: false,
                dataType: 'json',
            };
            if (!!localStorage.token) {
                defaultOptions.headers["Authorization"] = "Bearer " + localStorage.token;
            }
            return fetch(c.BASE_URL + '/productos/?' + query, defaultOptions);
        },
        getOne(idProducto) {
            let defaultOptions = {
                url: '',
                method: 'GET',
                mode: 'cors',
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    "Content-Type": "application/json;charset=UTF-8",
                    
                },
                // cache: false,
                dataType: 'json',
            };
            if (!!localStorage.token) {
                defaultOptions.headers["Authorization"] = "Bearer " + localStorage.token;
            }
            return fetch(c.BASE_URL + '/productos/' + idProducto, defaultOptions);
        },

        saveCreate(nuevo, files) {
    var formData = new FormData();
    if (files) {
        files.forEach((file) => {
            if(file)
                formData.append(file.name, file);
        });
    }
    formData.append("producto", JSON.stringify(nuevo));
    return $.ajax({
        url: c.BASE_URL + '/productos/',
        //dataType: 'json',
        data: formData,
        beforeSend: function (xhr) {
            xhr.setRequestHeader('authorization', "Bearer " + localStorage.token);
            
        },
        contentType: false,
        type: 'POST',
        processData: false,
        enctype: 'multipart/form-data',
    });

},
        saveUpdate(activo, files) {
    var formData = new FormData();
    if (files) {
        files.forEach((file) => {
            if(file)
                formData.append(file.name, file);
        });
    }

    formData.append("producto", JSON.stringify(activo));
    return $.ajax({
        url: c.BASE_URL + '/productos/' + activo.id,
        //dataType: 'json',
        data: formData,
        beforeSend: function (xhr) {
            xhr.setRequestHeader('authorization', "Bearer " + localStorage.token);
            
        },
        contentType: false,
        type: 'POST',
        processData: false,
        enctype: 'multipart/form-data',
    });
},
          saveUpdateProductos(activos) {
                 let defaultOptions = {
                     url: '',
                     method: 'PUT',
                     mode: 'cors',
                     headers: {
                         'Access-Control-Allow-Origin': '*',
                         "Content-Type": "application/json;charset=UTF-8",
                         "Authorization": "Bearer " + localStorage.token,
                         
                     },
                     // cache: false,
                     dataType: 'json',
                     body: JSON.stringify(activos)
                 };
            if (!!localStorage.token) {
               defaultOptions.headers["Authorization"] = "Bearer " + localStorage.token;
            }
                 return fetch(c.BASE_URL + '/productos/all', defaultOptions);
             },
             saveDelete(producto) {
                     let defaultOptions = {
                         url: '',
                         method: 'DELETE',
                         mode: 'cors',
                         headers: {
                             'Access-Control-Allow-Origin': '*',
                             "Content-Type": "application/json;charset=UTF-8",
                             "Authorization": "Bearer " + localStorage.token,
                             
                         },
                         // cache: false,
                         dataType: 'json',
                     };
            if (!!localStorage.token) {
                defaultOptions.headers["Authorization"] = "Bearer " + localStorage.token;
            }
                     return fetch(c.BASE_URL + '/productos/' + producto.id, defaultOptions);
                 },
         saveCreateProductos(nuevos) {
              let defaultOptions = {
                  url: '',
                  method: 'POST',
                  mode: 'cors',
                  headers: {
                      'Access-Control-Allow-Origin': '*',
                      "Content-Type": "application/json;charset=UTF-8",
                      "Authorization": "Bearer " + localStorage.token,
                      
                  },
                  // cache: false,
                  dataType: 'json',
                  body: JSON.stringify(nuevos)
              };
             if (!!localStorage.token) {
                defaultOptions.headers["Authorization"] = "Bearer " + localStorage.token;
             }
                  return fetch(c.BASE_URL + '/productos/all', defaultOptions);
              },
         printProducto(idProducto) {
                 let defaultOptions = {
                     url: '',
                     method: 'GET',
                     mode: 'cors',
                     headers: {
                         'Access-Control-Allow-Origin': '*',
                         "Content-Type": "multipart/form-data",
                         "Authorization": "Bearer " + localStorage.token,
                         
                     },
                     cache: "no-cache"
                 };
                 return fetch(c.BASE_URL + '/productos/' + idProducto + "/edit/", defaultOptions);
             },
    };

export default productos;